// extracted by mini-css-extract-plugin
export var center = "text-promo-module--center--BQQDx";
export var leftAlign = "text-promo-module--leftAlign--Js5vy";
export var textPromo = "text-promo-module--textPromo--QsV--";
export var withComponentSpacing = "text-promo-module--withComponentSpacing--0V+x1";